import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./responsive.css";
import { initAnalytics } from './analytics';

initAnalytics();
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

